// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAddress
 */
export interface IAddress {
    /**
     * 
     * @type {string}
     * @memberof IAddress
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof IAddress
     */
    house_number_or_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IAddress
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof IAddress
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof IAddress
     */
    state_or_province: string;
    /**
     * 
     * @type {string}
     * @memberof IAddress
     */
    postal_code: string;
    /**
     * 
     * @type {string}
     * @memberof IAddress
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof IAddress
     */
    formatted?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IAddress
     */
    primary?: boolean;
}

/**
 * Check if a given object implements the IAddress interface.
 */
export function instanceOfIAddress(value: object): value is IAddress {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state_or_province' in value) || value['state_or_province'] === undefined) return false;
    if (!('postal_code' in value) || value['postal_code'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function IAddressFromJSON(json: any): IAddress {
    return IAddressFromJSONTyped(json, false);
}

export function IAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'house_number_or_name': json['houseNumberOrName'] == null ? undefined : json['houseNumberOrName'],
        'street': json['street'],
        'city': json['city'],
        'state_or_province': json['stateOrProvince'],
        'postal_code': json['postalCode'],
        'country': json['country'],
        'formatted': json['formatted'] == null ? undefined : json['formatted'],
        'primary': json['primary'] == null ? undefined : json['primary'],
    };
}

export function IAddressToJSON(json: any): IAddress {
    return IAddressToJSONTyped(json, false);
}

export function IAddressToJSONTyped(value?: IAddress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'houseNumberOrName': value['house_number_or_name'],
        'street': value['street'],
        'city': value['city'],
        'stateOrProvince': value['state_or_province'],
        'postalCode': value['postal_code'],
        'country': value['country'],
        'formatted': value['formatted'],
        'primary': value['primary'],
    };
}

